import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PageComponent } from '@shared/components';
import { ContentPageId, FlowTypes, urlMapper } from '@shared/models';
import { PortfolioMatchContent } from '@shared/services/content/content-jsons/open-choice/portfolio-match.content';
import {
  rejectDAOffer,
  UpdatePortfolioMatchResult,
} from '@store/actions/open-choice/open-choice.actions';
import * as fromRootStore from '@store/index';
import { Go, LogError } from '@store/index';
import { getFlowTypeSelection } from '@store/reducers/triage/triage.reducer';
import { Observable, of } from 'rxjs';

import { RiskPreference } from '../../../../../interfaces/open-choice/risk-preference.model';
import { RiskDescriptionEnum } from '../../../../../interfaces/open-choice/risk-quiz.enum';
import { getRiskAttitude } from '../helper/risk-attitude.helper';

@Component({
  selector: 'app-portfolio-match',
  templateUrl: './portfolio-match.component.html',
  styleUrl: './portfolio-match.component.scss',
})
export class PortfolioMatchComponent extends PageComponent implements OnInit, OnDestroy {
  content = PortfolioMatchContent;
  flow: FlowTypes | null = null;

  constructor(globalStore: Store<fromRootStore.State>) {
    super(ContentPageId.taxFilingRetirement, globalStore);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subs.add(
      this.globalStore.pipe(select(fromRootStore.selectTriageState)).subscribe((triage) => {
        this.flow = getFlowTypeSelection(triage);
      }),
    );
  }

  resultHandler(event: CustomEvent<RiskPreference>): void {
    if (event?.detail) {
      const riskAttitude: RiskDescriptionEnum = getRiskAttitude(event.detail);
      this.globalStore.dispatch(UpdatePortfolioMatchResult({ payload: riskAttitude }));
      this.globalStore.dispatch(fromRootStore.Next());
    }
  }

  errorHandler(event: CustomEvent) {
    const errorDetails = JSON.stringify(event.detail);
    this.globalStore.dispatch(
      LogError({
        payload: {
          eventId: 'open-choice-portfolio-match-assessment--error',
          errorDetails,
        },
      }),
    );
    this.globalStore.dispatch(fromRootStore.rejectDAOffer());
    this.globalStore.dispatch(fromRootStore.UpdateDAComponentFailure({ payload: true }));
    if (this.flow && this.flow !== FlowTypes.INTERNAL && this.flow !== FlowTypes.MULT) {
      this.globalStore.dispatch(
        fromRootStore.Go({ path: [`secure/${urlMapper[this.flow]}/review`] }),
      );
    } else {
      this.globalStore.dispatch(fromRootStore.Go({ path: ['error'] }));
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
